<template>
	<div class="book-button restButton-bottom-right" @click="toggleRestWidgets">
		<slot />
	</div>
</template>

<script setup>
function toggleRestWidgets() {
	const widget = document.getElementById('restWidget');
	const widgetClose = document.getElementById('restWidgetClose');

	if (widget) {
		widget.classList.toggle('show');
	}
	if (widgetClose) {
		widgetClose.classList.toggle('show');
	}
}
</script>

<style lang="scss" scoped>
.book-button {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
